export enum FIELD_TYPES {
  string = 'string',
  number = 'number',
  integer = 'integer',
  boolean = 'boolean',
  date = 'date',
  object = 'object',
  break = 'break',
  button = 'button',
}

export const enum FIELD_DISPLAY_OPTIONS {
  withAge = 'withAge',
}

export const RULE_REGEXP = {
  EMAIL: /^\w+(['+.-]\w+)*@\w+([.-]\w+)*\.\w+([.-]\w+)*$/,
  INTEGER: /^-?[\d-]+$/,
  NUMBER: /^-?\d*[,.\\|]{0,1}\d+.*$/,
  PHONE_NUMBER:
    /^(?:(?:\+|00)[1-9]{0,3}[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/,
}

export enum FIELD_SET_DISPLAY_TYPES {
  autocompleteAddress = 'autocompleteAddress',
  selectButtons = 'selectButtons',
  slider = 'slider',
  sliderRepartition = 'sliderRepartition',
}

export enum ENUM_SORTING_RULE {
  alphabeticalLabel = 'alphabeticalLabel',
}
